// import Main from "../../components/layout/Main";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Breadcrumb, Tabs, Button } from "antd";
// import CalanderchackGreen from "../../assets/images/calander-check-green.svg";
// import TeamredBg from "../../assets/images/team-red-background.svg";
// import Teamredbanner from "../../assets/images/team-red-banner.svg";
// import TeamredLogoFox from "../../assets/images/fox-logo.svg";
// import LiningImage from "../../assets/images/line & dot.svg";
// import TeamredLogoBull from "../../assets/images/bull-logo.svg";
// import WinnerCrownIcon from "../../assets/images/winner-crown-icon.svg";
// import { useTournament } from "../../context/TournamentContext";
// import { useParams } from "react-router-dom";
// import { Severty, ShowToast } from "../../helper/toast";
// import ScoreModal from "../../components/ScoreModal";
// import { isValidUrl } from "../../helper/functions";

// const Brackets = () => {
//   const { id } = useParams();
//   const [tournamentData, setTournament] = useState();
//   const [brackets, setBrackets] = useState([]);
//   const [scoreData, setScoreData] = useState();
//   const [openScoreModal, setOpenScoreModal] = useState(false);
//   const [selectedTeam, setSelectedTeam] = useState(null);

//   const {
//     viewBrackets,
//     loadTournament,
//     updateTeamScore,
//     progressToNextRound,
//     endFinalRound,
//   } = useTournament();

//   // ---------- Handlers -----------
//   const fetchTournament = async () => {
//     try {
//       const response = await loadTournament(id);
//       if (response.data.status === 200) {
//         const data = response.data.data.tournament;
//         setTournament(data);
//       }
//       const result = await viewBrackets(id);
//       if (result.data.status === 200) {
//         setBrackets(result.data.data.bracket);
//         // setRules(result.data.data.tournament.rules);
//       }
//     } catch (error) {
//       console.error("Error loading tournament", error);
//     }
//   };

//   // ---------- Update Score API Call ----------
//   const handleSaveScore = async (value) => {
//     const data = { ...scoreData, score: value, tournamentId: id };
//     const response = await updateTeamScore(data);
//     if (response.status === 200) {
//       ShowToast(response.data.message, Severty.SUCCESS);
//     }
//     setOpenScoreModal(false);
//     fetchTournament();
//   };

//   // ---------- Open modal and set score data ------
//   const handleScoreModal = (data) => {
//     if (tournamentData.status === "Active") {
//       if (data.status === true) {
//         ShowToast("Score already updated", Severty.ERROR);
//         return;
//       }
//       setOpenScoreModal(true);
//       setScoreData(data);
//     }
//   };

//   // ---------- Handle Next Round --------------
//   const handleNextRound = async (item) => {
//     try {
//       let response;
//       if (item === "Final") {
//         response = await endFinalRound(id);
//         fetchTournament();
//       } else {
//         response = await progressToNextRound(id);
//         fetchTournament();
//       }
//       if (response.status === 200) {
//         ShowToast(response.data.message, Severty.SUCCESS);
//       }
//     } catch (error) {
//       ShowToast(error.data, Severty.ERROR);
//       console.log("Error occured while handle next round", error);
//     }
//   };

//   //---------- Handle Declare Winner ------------
//   const handleDeclareWinner = async (match) => {
//     try {
//       const response = await updateTeamScore({
//         teamId: selectedTeam,
//         tournamentId: id,
//         matchId: match._id,
//       });
//       if (response.status === 200) {
//         ShowToast(response.data.message, Severty.SUCCESS);
//       }
//       console.log("winner response", response);
//     } catch (error) {
//       ShowToast(error.data, Severty.ERROR);
//       console.log("Error occured while declare winner", error);
//     }
//   };

//   console.log("tournament data", tournamentData.format);

//   // ------ use effects ------
//   useEffect(() => {
//     fetchTournament();
//   }, []);

//   return (
//     <Main>
//       {/* When tournament is live  */}
//       {/* {tournamentData?.status === "Active" && ( */}
//       <>
//         <div className="bracket-main-section">
//           {brackets &&
//             Object.keys(brackets).map((item, index) => (
//               <div className="bracket-round-div-main" key={index}>
//                 <div className="bracket-round-div bracket-round-div-green">
//                   <h4>{item}</h4>
//                   <div className="bracket-round-div-image">
//                     <img src={CalanderchackGreen} />
//                   </div>
//                 </div>
//                 {/* -------- Brackets --------- */}

//                 {tournamentData.format === "BR" ? (
//                   <div className="br-match-container">
//                     {brackets[item].map((match) => (
//                       <section>
//                         <div className="br-match-container" key={match._id}>
//                           {match.participants.map((p) => (
//                             <label
//                               key={p.team._id}
//                               className={`br-team-card ${
//                                 selectedTeam === p.team._id ? "selected" : ""
//                               }`}
//                             >
//                               <input
//                                 type="radio"
//                                 name={`winner-${match._id}`}
//                                 value={p.team._id}
//                                 checked={
//                                   selectedTeam === p.team._id ||
//                                   match?.winnerId?._id === p.team._id
//                                 }
//                                 onChange={() => setSelectedTeam(p.team._id)}
//                                 className="br-radio"
//                               />

//                               <div className="br-team-content">
//                                 <img
//                                   src={
//                                     p.team.image ||
//                                     "https://via.placeholder.com/40?text=No+Img"
//                                   }
//                                   className="br-team-image"
//                                   alt={p.team.teamName}
//                                 />

//                                 <div className="br-team-info">
//                                   <div className="br-team-name">
//                                     {p.team.teamName}
//                                   </div>
//                                   <div className="br-team-id">
//                                     {p.team.teamId}
//                                   </div>
//                                   {/* 🔥 Crown on winner */}
//                                   {match?.winnerId &&
//                                     match?.winnerId?._id === p.team._id && (
//                                       <img
//                                         src={WinnerCrownIcon}
//                                         alt="winner"
//                                         className="br-winner-crown"
//                                       />
//                                     )}
//                                 </div>
//                               </div>
//                             </label>
//                           ))}
//                         </div>
//                         <div>
//                           {tournamentData.format === "BR" && (
//                             <div
//                               className="brackets-next-final-button"
//                               style={{ margin: "15px" }}
//                               onClick={() => handleDeclareWinner(match)}
//                             >
//                               <Button className="ant-btn ant-btn-default Fill-button">
//                                 Declare Winner
//                               </Button>
//                             </div>
//                           )}
//                         </div>
//                       </section>
//                     ))}
//                   </div>
//                 ) : (
//                   brackets[item].map((match, index) => (
//                     <div className="final-main-div-new" key={index}>
//                       <div className="semifinal-main-sections-kl">
//                         <div className="team-card-main-all-semifinal">
//                           <div className="team-card-main-all-inner">
//                             <div className="team-card-main-all">
//                               <div className="team-card-main">
//                                 <div className="tram-cards">
//                                   <div className="team-red-card">
//                                     <img
//                                       className="team-banner-main"
//                                       src={Teamredbanner}
//                                     />
//                                     <img
//                                       className="team-banner-background"
//                                       src={TeamredBg}
//                                     />
//                                     <img
//                                       className="team-banner-logo"
//                                       src={
//                                         isValidUrl(match?.team1Id?.image)
//                                           ? match?.team1Id?.image
//                                           : TeamredLogoFox
//                                       }
//                                     />
//                                     {match?.winnerId?.teamId ===
//                                       match?.team1Id?.teamId && (
//                                       <img
//                                         className="team-banner-crown-icob"
//                                         src={WinnerCrownIcon}
//                                       />
//                                     )}
//                                     <div className="team-banner-team-name">
//                                       {match?.team1Id?.teamName}
//                                     </div>
//                                     <div
//                                       className={
//                                         match?.winnerId?.teamId ===
//                                         match?.team1Id?.teamId
//                                           ? "team-points-divv-green"
//                                           : "team-points-divv-black"
//                                       }
//                                       onClick={() =>
//                                         handleScoreModal({
//                                           matchId: match._id,
//                                           teamId: match?.team1Id?._id,
//                                           status:
//                                             match.team1ScoreUpdates == 1
//                                               ? true
//                                               : false,
//                                         })
//                                       }
//                                       style={{
//                                         cursor:
//                                           tournamentData.status === "Active"
//                                             ? "pointer"
//                                             : "default",
//                                       }}
//                                     >
//                                       {match?.team1Score?.[0] || 0}
//                                     </div>
//                                     <div
//                                       className={
//                                         match?.winnerId?.teamId ===
//                                         match?.team1Id?.teamId
//                                           ? "team-points-divv-green"
//                                           : "team-points-divv-black"
//                                       }
//                                       onClick={() =>
//                                         handleScoreModal({
//                                           matchId: match._id,
//                                           teamId: match?.team1Id?._id,
//                                           status:
//                                             match.team1ScoreUpdates == 1
//                                               ? true
//                                               : false,
//                                         })
//                                       }
//                                       style={{
//                                         cursor:
//                                           tournamentData.status === "Active"
//                                             ? "pointer"
//                                             : "default",
//                                       }}
//                                     >
//                                       {match?.team1Score?.[1] || 0}
//                                     </div>
//                                   </div>
//                                   <div className="winner-time">
//                                     {/* <img
//                       className="team-banner-lining"
//                       src={LiningImage}
//                     /> */}
//                                     <span> VS</span>
//                                   </div>
//                                   <div className="team-green-card">
//                                     <img
//                                       className="team-banner-main"
//                                       src={Teamredbanner}
//                                     />
//                                     <img
//                                       className="team-banner-background"
//                                       src={TeamredBg}
//                                     />
//                                     <img
//                                       className="team-banner-logo"
//                                       src={
//                                         isValidUrl(match?.team1Id?.image)
//                                           ? match?.team2Id?.image
//                                           : TeamredLogoBull
//                                       }
//                                     />
//                                     {match?.winnerId?.teamId ===
//                                       match?.team2Id?.teamId && (
//                                       <img
//                                         className="team-banner-crown-icob"
//                                         src={WinnerCrownIcon}
//                                       />
//                                     )}
//                                     <div className="team-banner-team-name">
//                                       {match?.team2Id?.teamName}
//                                     </div>
//                                     <div
//                                       className={
//                                         match?.winnerId?.teamId ===
//                                         match?.team2Id?.teamId
//                                           ? "team-points-divv-green"
//                                           : "team-points-divv-black"
//                                       }
//                                       onClick={() =>
//                                         handleScoreModal({
//                                           matchId: match._id,
//                                           teamId: match?.team2Id?._id,
//                                           status:
//                                             match.team2ScoreUpdates == 1
//                                               ? true
//                                               : false,
//                                         })
//                                       }
//                                       style={{
//                                         cursor:
//                                           tournamentData.status === "Active"
//                                             ? "pointer"
//                                             : "default",
//                                       }}
//                                     >
//                                       {match?.team2Score?.[0] || 0}
//                                     </div>
//                                     <div
//                                       className={
//                                         match?.winnerId?.teamId ===
//                                         match?.team2Id?.teamId
//                                           ? "team-points-divv-green"
//                                           : "team-points-divv-black"
//                                       }
//                                       onClick={() =>
//                                         handleScoreModal({
//                                           matchId: match._id,
//                                           teamId: match?.team2Id?._id,
//                                           status:
//                                             match.team2ScoreUpdates == 1
//                                               ? true
//                                               : false,
//                                         })
//                                       }
//                                       style={{
//                                         cursor:
//                                           tournamentData.status === "Active"
//                                             ? "pointer"
//                                             : "default",
//                                       }}
//                                     >
//                                       {match?.team2Score?.[1] || 0}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 )}

//                 {!(tournamentData.format === "BR") && (
//                   <div
//                     className="brackets-next-final-button"
//                     style={{ margin: "15px" }}
//                     // onClick={() =>
//                     //   tournamentData.format === "BR"
//                     //     ? handleDeclareWinner(selectedTeam)
//                     //     :
//                     // }
//                     onClick={() => handleNextRound(item)}
//                   >
//                     <Button className="ant-btn ant-btn-default Fill-button">
//                       {/* {tournamentData?.format === "BR"
//                           ? "Declare Winner"
//                           : item === "Final"
//                           ? "End Final"
//                           : "Process to next round"} */}
//                       {item === "Final" ? "End Final" : "Process to next round"}
//                     </Button>
//                   </div>
//                 )}
//               </div>
//             ))}
//         </div>

//         {/* Score modal */}
//         <ScoreModal
//           open={openScoreModal}
//           onClose={() => setOpenScoreModal(false)}
//           onSave={handleSaveScore}
//         />
//       </>
//       {/* )} */}
//     </Main>
//   );
// };

// export default Brackets;

import Main from "../../components/layout/Main";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Tabs, Button } from "antd";
import CalanderchackGreen from "../../assets/images/calander-check-green.svg";
import TeamredBg from "../../assets/images/team-red-background.svg";
import Teamredbanner from "../../assets/images/team-red-banner.svg";
import TeamredLogoFox from "../../assets/images/fox-logo.svg";
import TeamredLogoBull from "../../assets/images/bull-logo.svg";
import WinnerCrownIcon from "../../assets/images/winner-crown-icon.svg";
import { useTournament } from "../../context/TournamentContext";
import { useParams } from "react-router-dom";
import { Severty, ShowToast } from "../../helper/toast";
import ScoreModal from "../../components/ScoreModal";
import { isValidUrl } from "../../helper/functions";

const Brackets = () => {
  const { id } = useParams();
  const [tournamentData, setTournament] = useState();
  const [brackets, setBrackets] = useState([]);
  const [scoreData, setScoreData] = useState();
  const [openScoreModal, setOpenScoreModal] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [activeRound, setActiveRound] = useState("");

  const {
    viewBrackets,
    loadTournament,
    updateTeamScore,
    progressToNextRound,
    endFinalRound,
  } = useTournament();

  // ---------- Handlers -----------
  const fetchTournament = async () => {
    try {
      const response = await loadTournament(id);
      if (response.data.status === 200) {
        const data = response.data.data.tournament;
        setTournament(data);
      }
      const result = await viewBrackets(id);
      if (result.data.status === 200) {
        setBrackets(result.data.data.bracket);
      }
    } catch (error) {
      console.error("Error loading tournament", error);
    }
  };

  // ---------- Update Score API Call ----------
  const handleSaveScore = async (value) => {
    // 🔥 scoreIndex bhi send kar sakte ho (Double elim ke liye)
    const data = { ...scoreData, score: value, tournamentId: id };
    const response = await updateTeamScore(data);
    if (response.status === 200) {
      ShowToast(response.data.message, Severty.SUCCESS);
    }
    setOpenScoreModal(false);
    fetchTournament();
  };

  // ---------- Open modal and set score data ------
  const handleScoreModal = (data) => {
    if (!tournamentData) return;

    if (tournamentData.status === "Active") {
      if (data.status === true) {
        ShowToast("Score already updated", Severty.ERROR);
        return;
      }
      setOpenScoreModal(true);
      setScoreData(data);
    }
  };

  // ---------- Handle Next Round --------------
  const handleNextRound = async (item) => {
    try {
      let response;
      if (item === "Final" || item === "Bronze Match") {
        response = await endFinalRound(id);
        fetchTournament();
      } else {
        response = await progressToNextRound(id);
        fetchTournament();
      }
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      ShowToast(errorMsg, Severty.ERROR);
      console.log("Error occured while handle next round", error);
    }
  };

  //---------- Handle Declare Winner (BR) ------------
  const handleDeclareWinner = async (match) => {
    try {
      const response = await updateTeamScore({
        teamId: selectedTeam,
        tournamentId: id,
        matchId: match._id,
      });
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
      }
      console.log("winner response", response);
      fetchTournament();
    } catch (error) {
      ShowToast(error.data, Severty.ERROR);
      console.log("Error occured while declare winner", error);
    }
  };

  const getActiveRound = () => {
    const roundNames = Object.keys(brackets);

    for (let i = 0; i < roundNames.length; i++) {
      const round = roundNames[i];
      const matches = brackets[round];

      // Agar is round me koi match aisa hai jiska winner nahi decide hua
      const isPending = matches.some((m) => !m.winnerId);

      if (isPending) return round;
    }

    // Agar sab complete hain to last round ko consider karo
    return roundNames[roundNames.length - 1];
  };

  useEffect(() => {
    fetchTournament();
  }, []);

  useEffect(() => {
    if (brackets) {
      setActiveRound(getActiveRound());
    }
  }, [brackets]);

  const isDoubleElimination = tournamentData?.eliminationType === "Double";

  return (
    <Main>
      <>
        <div className="bracket-main-section">
          {brackets &&
            Object.keys(brackets).map((item, index) => {
              const isFinalRound = item === "Final" || item === "Bronze Match";

              return (
                <div className="bracket-round-div-main" key={index}>
                  <div className="bracket-round-div bracket-round-div-green">
                    <h4>{item}</h4>
                    <div className="bracket-round-div-image">
                      <img src={CalanderchackGreen} />
                    </div>
                  </div>

                  {/* -------- Brackets --------- */}
                  {tournamentData?.format === "BR" ? (
                    // =================== BR FORMAT ===================
                    <div className="br-match-container">
                      {brackets[item].map((match) => (
                        <section key={match._id}>
                          <div className="br-match-container">
                            {match.participants.map((p) => (
                              <label
                                key={p.team._id}
                                className={`br-team-card ${
                                  selectedTeam === p.team._id ? "selected" : ""
                                }`}
                              >
                                <input
                                  type="radio"
                                  name={`winner-${match._id}`}
                                  value={p.team._id}
                                  checked={
                                    selectedTeam === p.team._id ||
                                    match?.winnerId?._id === p.team._id
                                  }
                                  onChange={() => setSelectedTeam(p.team._id)}
                                  className="br-radio"
                                />

                                <div className="br-team-content">
                                  <img
                                    src={
                                      p.team.image ||
                                      "https://via.placeholder.com/40?text=No+Img"
                                    }
                                    className="br-team-image"
                                    alt={p.team.teamName}
                                  />

                                  <div className="br-team-info">
                                    <div className="br-team-name">
                                      {p.team.teamName}
                                    </div>
                                    <div className="br-team-id">
                                      {p.team.teamId}
                                    </div>
                                    {match?.winnerId &&
                                      match?.winnerId?._id === p.team._id && (
                                        <img
                                          src={WinnerCrownIcon}
                                          alt="winner"
                                          className="br-winner-crown"
                                        />
                                      )}
                                  </div>
                                </div>
                              </label>
                            ))}
                          </div>

                          {tournamentData.format === "BR" && (
                            <div
                              className="brackets-next-final-button"
                              style={{ margin: "15px" }}
                              onClick={() => handleDeclareWinner(match)}
                            >
                              <Button className="ant-btn ant-btn-default Fill-button">
                                Declare Winner
                              </Button>
                            </div>
                          )}
                        </section>
                      ))}
                    </div>
                  ) : (
                    // =================== NORMAL FORMAT (NON-BR) ===================

                    brackets[item].map((match, idx) => {
                      // helpers per match
                      const team1Scores = match?.team1Score || [];
                      const team2Scores = match?.team2Score || [];
                      const team1Updates = match?.team1ScoreUpdates || 0;
                      const team2Updates = match?.team2ScoreUpdates || 0;

                      const showTwoBoxes = isDoubleElimination && !isFinalRound; // 🔥 condition

                      return (
                        <section>
                          <div className="final-main-div-new" key={idx}>
                            <div className="semifinal-main-sections-kl">
                              <div className="team-card-main-all-semifinal">
                                <div className="team-card-main-all-inner">
                                  <div className="team-card-main-all">
                                    <div className="team-card-main">
                                      <div className="tram-cards">
                                        {/* ================= TEAM 1 CARD ================= */}
                                        <div className="team-red-card">
                                          <img
                                            className="team-banner-main"
                                            src={Teamredbanner}
                                          />
                                          <img
                                            className="team-banner-background"
                                            src={TeamredBg}
                                          />
                                          <img
                                            className="team-banner-logo"
                                            src={
                                              isValidUrl(match?.team1Id?.image)
                                                ? match?.team1Id?.image
                                                : TeamredLogoFox
                                            }
                                          />
                                          {match?.winnerId?.teamId ===
                                            match?.team1Id?.teamId && (
                                            <img
                                              className="team-banner-crown-icob"
                                              src={WinnerCrownIcon}
                                            />
                                          )}
                                          <div className="team-banner-team-name">
                                            {match?.team1Id?.teamName}
                                          </div>

                                          {/* 🔥 TEAM 1 SCORE BOXES (Single / Double) */}
                                          {showTwoBoxes ? (
                                            <>
                                              {/* First box - index 0 */}
                                              <div
                                                className={
                                                  match?.winnerId?.teamId ===
                                                  match?.team1Id?.teamId
                                                    ? "team-points-divv-green"
                                                    : "team-points-divv-black"
                                                }
                                                onClick={() => {
                                                  if (team1Updates >= 1) return;
                                                  handleScoreModal({
                                                    matchId: match._id,
                                                    teamId: match?.team1Id?._id,
                                                    scoreIndex: 0,
                                                    status: team1Updates >= 1, // 🔥 first update done?
                                                  });
                                                }}
                                                style={{
                                                  cursor:
                                                    tournamentData?.status ===
                                                    "Active"
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                              >
                                                {team1Scores[0] || 0}
                                              </div>

                                              {/* Second box - index 1 */}
                                              <div
                                                className={
                                                  match?.winnerId?.teamId ===
                                                  match?.team1Id?.teamId
                                                    ? "team-points-divv-green"
                                                    : "team-points-divv-black"
                                                }
                                                onClick={() => {
                                                  if (team1Updates !== 1)
                                                    return;
                                                  handleScoreModal({
                                                    matchId: match._id,
                                                    teamId: match?.team1Id?._id,
                                                    scoreIndex: 1,
                                                    // status: team1Updates >= 2, // 🔥 second update done?
                                                    status: team1Updates !== 1,
                                                  });
                                                }}
                                                style={{
                                                  cursor:
                                                    tournamentData?.status ===
                                                    "Active"
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                              >
                                                {team1Scores[1] || 0}
                                              </div>
                                            </>
                                          ) : (
                                            // 🔥 Single elimination OR Final → single box only
                                            <div
                                              className={
                                                match?.winnerId?.teamId ===
                                                match?.team1Id?.teamId
                                                  ? "team-points-divv-green"
                                                  : "team-points-divv-black"
                                              }
                                              onClick={() =>
                                                handleScoreModal({
                                                  matchId: match._id,
                                                  teamId: match?.team1Id?._id,
                                                  scoreIndex: 0,
                                                  status: team1Updates >= 1,
                                                })
                                              }
                                              style={{
                                                cursor:
                                                  tournamentData?.status ===
                                                  "Active"
                                                    ? "pointer"
                                                    : "default",
                                              }}
                                            >
                                              {team1Scores[0] || 0}
                                            </div>
                                          )}
                                        </div>

                                        <div className="winner-time">
                                          <span> VS</span>
                                        </div>

                                        {/* ================= TEAM 2 CARD ================= */}
                                        <div className="team-green-card">
                                          <img
                                            className="team-banner-main"
                                            src={Teamredbanner}
                                          />
                                          <img
                                            className="team-banner-background"
                                            src={TeamredBg}
                                          />
                                          <img
                                            className="team-banner-logo"
                                            src={
                                              isValidUrl(match?.team2Id?.image)
                                                ? match?.team2Id?.image
                                                : TeamredLogoBull
                                            }
                                          />
                                          {match?.winnerId?.teamId ===
                                            match?.team2Id?.teamId && (
                                            <img
                                              className="team-banner-crown-icob"
                                              src={WinnerCrownIcon}
                                            />
                                          )}
                                          <div className="team-banner-team-name">
                                            {match?.team2Id?.teamName}
                                          </div>

                                          {/* 🔥 TEAM 2 SCORE BOXES (Single / Double) */}
                                          {showTwoBoxes ? (
                                            <>
                                              {/* First box - index 0 */}
                                              <div
                                                className={
                                                  match?.winnerId?.teamId ===
                                                  match?.team2Id?.teamId
                                                    ? "team-points-divv-green"
                                                    : "team-points-divv-black"
                                                }
                                                onClick={() => {
                                                  if (team2Updates >= 1) return;
                                                  handleScoreModal({
                                                    matchId: match._id,
                                                    teamId: match?.team2Id?._id,
                                                    scoreIndex: 0,
                                                    status: team2Updates >= 1,
                                                  });
                                                }}
                                                style={{
                                                  cursor:
                                                    tournamentData?.status ===
                                                    "Active"
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                              >
                                                {team2Scores[0] || 0}
                                              </div>

                                              {/* Second box - index 1 */}
                                              <div
                                                className={
                                                  match?.winnerId?.teamId ===
                                                  match?.team2Id?.teamId
                                                    ? "team-points-divv-green"
                                                    : "team-points-divv-black"
                                                }
                                                onClick={() => {
                                                  if (team2Updates !== 1)
                                                    return;
                                                  handleScoreModal({
                                                    matchId: match._id,
                                                    teamId: match?.team2Id?._id,
                                                    scoreIndex: 1,
                                                    // status: team2Updates >= 2,
                                                    status: team2Updates !== 1,
                                                  });
                                                }}
                                                style={{
                                                  cursor:
                                                    tournamentData?.status ===
                                                    "Active"
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                              >
                                                {team2Scores[1] || 0}
                                              </div>
                                            </>
                                          ) : (
                                            // 🔥 Single elim or Final → single score box
                                            <div
                                              className={
                                                match?.winnerId?.teamId ===
                                                match?.team2Id?.teamId
                                                  ? "team-points-divv-green"
                                                  : "team-points-divv-black"
                                              }
                                              onClick={() =>
                                                handleScoreModal({
                                                  matchId: match._id,
                                                  teamId: match?.team2Id?._id,
                                                  scoreIndex: 0,
                                                  status: team2Updates >= 1,
                                                })
                                              }
                                              style={{
                                                cursor:
                                                  tournamentData?.status ===
                                                  "Active"
                                                    ? "pointer"
                                                    : "default",
                                              }}
                                            >
                                              {team2Scores[0] || 0}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      );
                    })
                  )}

                  {tournamentData?.format !== "BR" &&
                    item === activeRound &&
                    item !== "Bronze Match" &&
                    tournamentData.status === "Active" && (
                      <div
                        className="brackets-next-final-button"
                        style={{ margin: "15px" }}
                        onClick={() => handleNextRound(item)}
                      >
                        <Button className="ant-btn ant-btn-default Fill-button">
                          {item === "Final"
                            ? "End Final"
                            : "Process to next round"}
                        </Button>
                      </div>
                    )}
                </div>
              );
            })}
        </div>

        {/* Score modal */}
        <ScoreModal
          open={openScoreModal}
          onClose={() => setOpenScoreModal(false)}
          onSave={handleSaveScore}
        />
      </>
    </Main>
  );
};

export default Brackets;
